module.exports = __webpack_public_path__ + "static/media/codepin.b09c8cdd.jpg";